import { types } from './sidebar.types';

export const setPopoverContent = (data) => ({
    type: types.SET_POPOVER_CONTENT,
    payload: data,
});

export const showPopoverContent = () => ({
    type: types.SHOW_POPOVER_CONTENT,
});

export const closePopover = () => ({
    type: types.CLOSE_POPOVER,
});

export const setNamedList = (data) => ({
    type: types.SET_NAMED_LIST,
    payload: (data)
});

/**
 * action to set the sidebar collapsed state
 * @param {boolean} payload whether to open or close the sidebar
 * @returns {void}
 */
export const toggleSidebarCollapse = (payload) => ({
    type: types.TOGGLE_SIDEBAR_COLLAPSE,
    payload,
});
